//let host = "192.168.1.100"


let env = {
  // host: host,
  // apiUrl:"http://" + host + "/api/",
  // msgUrl: "http://10.33.10.33:9000",
  // wsUrl: "ws://" + host + ":8094",
  hardWare:"http://localhost:8080/data/hardware",
  oper_code:"2006"
}
let patInfo = {
  "patientid": "",
  "name": "",
  "idno": "",
  "idtype": "",
  "gender": "",
  "nation": "",
  "birthday": "",
  "age": "",
  "mobile": "",
  "address": "",
  "balance": 0,
  "selectDeptInfo":{},
  "selectDoctor":{}
  }
let tools = {
  getCurrentDate(){
    // 获取当前日期
    var date = new Date();
    // 获取当前月份
    var nowMonth = date.getMonth() + 1;
    // 获取当前是几号
    var strDate = date.getDate();
    // 添加分隔符“-”
    var seperator = "-";
    // 对月份进行处理，1-9月在前面添加一个“0”
    if (nowMonth >= 1 && nowMonth <= 9) {
      nowMonth = "0" + nowMonth;
    }
    // 对月份进行处理，1-9号在前面添加一个“0”
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    // 最后拼接字符串，得到一个格式为(yyyy-MM-dd)的日期
    var nowDate = date.getFullYear() + seperator + nowMonth + seperator + strDate;
    return nowDate
  },
  getCurrentDate_pre(day){
    // 获取当前日期
    var date = new Date();

    date.setDate(date.getDate() - day);
    // 获取当前月份
    var nowMonth = date.getMonth() + 1;
    // 获取当前是几号
    var strDate = date.getDate();
    // 添加分隔符“-”
    var seperator = "-";
    // 对月份进行处理，1-9月在前面添加一个“0”
    if (nowMonth >= 1 && nowMonth <= 9) {
      nowMonth = "0" + nowMonth;
    }
    // 对月份进行处理，1-9号在前面添加一个“0”
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    // 最后拼接字符串，得到一个格式为(yyyy-MM-dd)的日期
    var nowDate = date.getFullYear() + seperator + nowMonth + seperator + strDate;
    return nowDate
  },
  getNowDate(){
    var date = new Date();
    var seperator1="-";
    var seperator2=":";

    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    var minute = date.getMinutes();
    var hour = date.getHours();
    var second = date.getSeconds();

    // 对月份进行处理，1-9月在前面添加一个“0”
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    // 对月份进行处理，1-9号在前面添加一个“0”
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }

    if (hour >= 0 && hour <= 9) {
      hour = "0" + hour;
    }

    if (minute >= 0 && minute <= 9) {
      minute = "0" + minute;
    }

    if (second >= 0 && second <= 9) {
      second = "0" + second;
    }

    var currentdate = year + seperator1 + month + seperator1 + strDate + " " + hour + seperator2 + minute + seperator2 + second;

    return currentdate
  },
  getMonths(dt1,dt2){
    let date1 = dt1.split('-');//例：将2020-12-21 的-去掉
    date1 = parseInt(date1[0]) * 12 + parseInt(date1[1]);//将字符串转换为数字格式
    let date2 = dt2.split('-');
    date2 = parseInt(date2[0]) * 12 + parseInt(date2[1]);
    let months = date1-date2;
    return months
  },
  Arabia_to_Chinese(num){
    let fraction = ['角', '分'];
    let digit = [
            '零', '壹', '贰', '叁', '肆',
            '伍', '陆', '柒', '捌', '玖'
        ];
        let unit = [
            ['元', '万', '亿'],
            ['', '拾', '佰', '仟']
        ];
    let head = num < 0 ? '欠' : '';
    let num_tmp = Math.abs(num);
    let s = '';
    for (let i = 0; i < fraction.length; i++) {
        s += (digit[Math.floor(num_tmp * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
    }
    s = s || '整';
    num_tmp = Math.floor(num_tmp);
    for (let i = 0; i < unit[0].length && num_tmp > 0; i++) {
      let p = '';
      for (let j = 0; j < unit[1].length && num_tmp > 0; j++) {
        p = digit[num_tmp % 10] + unit[1][j] + p;
        num_tmp = Math.floor(num_tmp / 10);
      }
      s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
    }
    return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');
  }
}

let hosbranchid = "02"

export default {
  env,patInfo,tools,hosbranchid
}